import { Component, ElementRef, Injector, Type } from "@angular/core";
import { trigger, state, animate, transition, style } from "@angular/animations";

import { TradeDealPrimaryLookupService } from "shared/cubiq-services";

import { BfxTradeContextMenuComponent } from "app/bfx-blotter-trade/bfx-trade-contextmenu.component";
import { BfxFindDealsContextMenuService } from "app/bfx-find-deals/bfx-find-deals-contextmenu.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-find-deals-context-menu",
  templateUrl: "./html/bfx-find-deals-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  styleUrls: ["../bfx-base-blotter/bfx-base-blotter-contextmenu.less"],
  standalone: false,
})
export class BfxFindDealsContextMenu extends BfxTradeContextMenuComponent {
  constructor(
    injector: Injector,
    lookupService: TradeDealPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BfxFindDealsContextMenuService> {
    return BfxFindDealsContextMenuService;
  }
}
